<template>
    <div class="col-12 mt-4" v-if="currentJourney">
        <div class="card w-100">
            <div class="card-body px-4">
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <h2>Transport methods</h2>
                        <div class="mediums mt-3">
                            <div class="mediums d-flex align-items-center">
                                <div class="circle d-flex justify-content-center align-items-center text-center mr-2">
                                    <span class="d-block w-100">{{ icons.length }}</span>
                                </div>
                                <div v-for="(icon, index) in icons" :key="index" class="medium text-center d-inline-block mr-2">
                                    <svg-icon v-if="index != 0" aria-label="dotted line" class="mr-1" name="dotted-line" width="20px" height="auto"></svg-icon>
                                    <svg-icon :name="icon" aria-label="transport-icon" width="auto" height="1.5em"></svg-icon>
                                </div>
                            </div>
                            <div v-if="this.brand === 'lochlomond' && !isJourneySaved">
                                <div v-if="this.currentJourney.carbon_emission === lowestCo2" class="d-flex mt-3">
                                    <svg-icon name="lowest-emissions" width="auto" height="1.5em"></svg-icon>
                                    <p class="lowest ml-2">Lowest emissions</p>
                                </div>
                                <div v-if="this.currentJourney.carbon_emission === highestCo2" class="d-flex mt-3">
                                    <svg-icon name="lowest-emissions" class=" highest-emission" width="auto" height="1.5em"></svg-icon>
                                    <p class="highest ml-2">Highest emissions</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9 col-sm-12">
                        <div class="row">
                            <div class="col-12">
                                <h3 class="mt-1">Journey Details</h3>
                                <div v-if="showEnterpriseLogo || showCoWheelsLogo" class="carclub-logo" style="float:right">
                                    <a :href="carClubLink" target="_blank">
                                        <img v-if="showEnterpriseLogo" src="../assets/enterprise.png" />
                                        <img v-if="showCoWheelsLogo" src="../assets/co-wheels.png" />
                                    </a>
                                </div>
                                <p>
                                    <strong>Date of travel : {{ currentJourney.depart.departure_date }}</strong>
                                </p>
                                <div class="row">
                                    <div class="col-8 pl-0 d-flex">
                                        <div class="indicator-item d-inline-block col-5 ">
                                            <div style="width:200px">
                                                <p>Depart at:</p>
                                                <h2>{{ currentJourney.depart.departure_at }}</h2>
                                            </div>
                                        </div>
                                        <div class="time text-center flex-grow-1 ml-3">
                                            <p class="d-inline-block">Time</p>
                                            <svg-icon name="dotted-line-lg" class="w-100" width="auto"></svg-icon>
                                            <p>
                                                <strong>{{ currentJourney.depart.duration.text }}</strong>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-4 text-right">
                                        <div class="indicator-item d-inline-block pr-1">
                                            <p>Arrive at:</p>
                                            <h2>{{ currentJourney.depart.arrival_at }}</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="row pt-3 pb-3 mt-n1">
                                    <div class="col-6">
                                        <span class="mr-1">From:</span>
                                        <p>
                                            <strong> {{ currentJourney.origin }} </strong>
                                        </p>
                                    </div>
                                    <div class="col-6">
                                        <span class="mr-1">To:</span>
                                        <span
                                            ><p>
                                                <strong> {{ currentJourney.destination }} </strong>
                                            </p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row back-grey mt-20">
                                    <div class="col-md-6 col-12 pt-2 pb-2 ">
                                        <span>Estimated wait time:</span>
                                        <p>
                                            <strong> {{ currentJourney.depart.wait_time }} mins </strong>
                                        </p>
                                    </div>
                                    <div class="col-md-6 col-12 pt-2 pb-2">
                                        <span v-if="this.icons[0] === 'bike'">Estimated route gradient:</span>
                                        <span v-else>Estimated gradient when walking:</span>
                                        <p>
                                            <span class="text-right">
                                                <svg-icon name="chevron-up" width="auto" height="1em" class="pr-1"></svg-icon>
                                                <strong >{{ currentJourney.depart.elevationHighest }}</strong>
                                                <svg-icon class="pl-3 pr-1" name="chevron-down" width="auto" height="1em"></svg-icon>
                                                <strong>{{ currentJourney.depart.elevationLowest }}</strong>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="row mt-20 back-grey">
                                    <div class="col-md-6 col-12 pt-2 pb-2">
                                        <span>Estimated journey time:</span>
                                        <p>
                                            <strong> {{ currentJourney.depart.duration.text }}</strong>
                                        </p>
                                    </div>
                                    <div class="col-6 pt-2 pb-2">
                                        <span>Estimated price:</span>
                                        <p>
                                            <strong> {{ currentJourney.cost }} </strong>
                                        </p>
                                    </div>
                                </div>
                                <div class="row mt-20 back-grey ">
                                    <div class="col-6  pt-2 pb-2" v-if="(this.icons.length === 1 && this.icons[0] === 'bike') || this.icons[0] === 'walk'">
                                        <span>Total distance:</span>
                                        <p>
                                            <strong> {{ currentJourney.depart.distance.text }} </strong>
                                        </p>
                                    </div>
                                    <div class="col-6 pt-2 pb-2">
                                        <span>Estimated emissons:</span>
                                        <p>
                                            <strong> {{ currentJourney.carbon_emission }} kg CO<sub>2</sub> </strong>
                                        </p>
                                    </div>
                                </div>
                                <div class="row mt-20 pt-2">
                                    <div class="col-6 mt-3">
                                        <div class="d-md-flex align-items-center">
                                            <div class="circle-icon mr-2">
                                                <svg-icon class="circle-icon-svg" aria-label="toilet-icon" name="toilets" width="auto" color="#ffffff" height="1.5em"></svg-icon>
                                            </div>
                                            <span>{{ currentJourney.depart.destination_toilets.count }} Toilets near this route</span>
                                        </div>
                                    </div>
                                    <div class="col-6 mt-3">
                                        <div class="d-md-flex align-items-center mx-auto">
                                            <div class="circle-icon mr-2">
                                                <svg-icon aria-label="walk-icon" class="circle-icon-svg" name="walk" width="auto" color="#ffffff" height="1.5em"></svg-icon>
                                            </div>
                                            <span>{{ currentJourney.depart.walking_distance.text }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="currentJourney.return" class="col-lg-12 col-sm-12 my-3 text-sm-right">
                                <a class="show-journey-buttons" v-if="this.showingReturnType" href="javascript:void(0);" @toggle-type="toggleJourneyType" @click="toggleJourneyType(false)">Hide return journey</a>
                                <a class="show-journey-buttons" v-if="!this.showingReturnType" href="javascript:void(0);" @toggle-type="toggleJourneyType" @click="toggleJourneyType(true)">Show return journey</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- return -->
                <div v-if="this.showingReturnType && currentJourney.return" id="return-section" class="row">
                    <div class="col-md-3 col-sm-12">
                        <h2>Transport methods</h2>
                        <div class="mediums mt-3">
                            <div class="mediums d-flex align-items-center">
                                <div class="circle d-flex justify-content-center align-items-center text-center mr-2">
                                    <span class="d-block w-100">{{ icons.length }}</span>
                                </div>
                                <div v-for="(icon, index) in getIconNamesByStage('return')" :key="index" class="medium text-center d-inline-block mr-3">
                                    <svg-icon :aria-labelledby="icon + ' icon'" :name="icon" width="auto" height="1.5em"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9 col-sm-12">
                        <div class="row">
                            <div class="col-12">
                                <h3 class="mt-1">Return Journey Details</h3>
                                <p>
                                    <strong>Date of travel : {{ currentJourney.return.departure_date }}</strong>
                                </p>
                                <div class="row">
                                    <div class="col-8 pl-0 d-flex">
                                        <div class="indicator-item d-inline-block col-5 ">
                                            <div style="width:200px">
                                                <p>Depart at:</p>
                                                <h2>{{ currentJourney.return.departure_at }}</h2>
                                            </div>
                                        </div>
                                        <div class="time text-center flex-grow-1 ml-3">
                                            <p class="d-inline-block">Time</p>
                                            <svg-icon name="dotted-line-lg" class="w-100" width="auto"></svg-icon>
                                            <p>
                                                <strong>{{ currentJourney.return.duration.text }}</strong>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-4 text-right">
                                        <div class="indicator-item d-inline-block pr-1">
                                            <p>Arrive at:</p>
                                            <h2>{{ currentJourney.return.arrival_at }}</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="row pt-3 pb-3 mt-n1">
                                    <div class="col-6">
                                        <span class="mr-1">From:</span>
                                        <p>
                                            <strong>{{ currentJourney.destination }} </strong>
                                        </p>
                                    </div>
                                    <div class="col-6">
                                        <span class="mr-1">To:</span>
                                        <span>
                                            <p>
                                                <strong>{{ currentJourney.origin }}</strong>
                                            </p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row back-grey mt-20">
                                    <div class="col-md-6 col-12 pt-2 pb-2">
                                        <span>Estimated wait time:</span>
                                        <p>
                                            <strong>{{ currentJourney.return.wait_time }} mins</strong>
                                        </p>
                                    </div>
                                    <div class="col-6 pt-2 pb-2">
                                        <span>Estimated gradient when walking:</span>
                                        <p>
                                            <span class="text-right">
                                                <svg-icon name="chevron-up" width="auto" height="1em"></svg-icon>
                                                <strong>{{ currentJourney.return.elevationHighest }} </strong>
                                                <svg-icon name="chevron-down" width="auto" height="1em"></svg-icon>
                                                <strong>{{ currentJourney.return.elevationLowest }}</strong>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="row mt-20 back-grey">
                                    <div class="col-md-6 col-12 pt-2 pb-2">
                                        <span>Estimated journey time:</span>
                                        <p>
                                            <strong> {{ currentJourney.return.duration.text }} </strong>
                                        </p>
                                    </div>
                                    <div class="col-6 pt-2 pb-2">
                                        <span>Estimated price:</span>
                                        <p>
                                            <strong> {{ currentJourney.cost }} </strong>
                                        </p>
                                    </div>
                                </div>
                                <div class="row mt-20">
                                    <div class="col-12 back-grey pt-2 pb-2">
                                        <span>Estimated emissons:</span>
                                        <p>
                                            <strong> {{ currentJourney.carbon_emission }} kg CO<sub>2</sub> </strong>
                                        </p>
                                    </div>
                                </div>
                                <div class="row mt-20 back-grey">
                                    <div class="col-6 pt-2 pb-2" v-if="(this.icons.length === 1 && this.icons[0] === 'bike') || this.icons[0] === 'walk'">
                                        <span>Total distance:</span>
                                        <p>
                                            <strong>{{ currentJourney.return.distance.text }}</strong>
                                        </p>
                                    </div>
                                </div>
                                <div class="row mt-n1 pt-2">
                                    <div class="col-6 mt-3">
                                        <div class="d-md-flex align-items-center">
                                            <div class="circle-icon">
                                                <svg-icon class="circle-icon-svg" name="toilets" width="auto" color="#ffffff" height="1.5em"></svg-icon>
                                            </div>
                                            <span class="ml-2 ">{{ currentJourney.return.destination_toilets.count }} Toilets near this route</span>
                                        </div>
                                    </div>
                                    <div class="col-6 mt-3">
                                        <div class="d-md-flex align-items-center mx-auto">
                                            <div class="circle-icon">
                                                <svg-icon class="circle-icon-svg" name="walk" width="auto" color="#ffffff" height="1.5em"></svg-icon>
                                            </div>
                                            <span class="ml-2">{{ currentJourney.return.walking_distance.text }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="back-grey save-button-section container col-12 d-sm-block d-md-flex py-3">
                    <div class="col-md-3 col-sm-12">
                        <div v-if="getUserLogged()">
                            <b-button v-if="!isJourneySaved" class="full-green-btn "  @click="saveJourney()">
                                <span>Save Journey <svg-icon v-if="brand != 'sestran'" class="arrow-right-find" name="forward"></svg-icon></span>
                            </b-button>
                            <b-button v-else class="full-green-btn " disabled>
                                <span>Journey Saved <svg-icon v-if="brand != 'sestran'" class="arrow-right-find" name="forward"></svg-icon></span>
                            </b-button>
                        </div>
                        <div v-if="enableUserAccounts && !getUserLogged()">
                            <b-button class="full-green-btn "  @click="$router.push({ name: 'Register' })">
                                <span>Create account to save journey<svg-icon v-if="brand != 'sestran'" class="arrow-right-find" name="forward"></svg-icon></span>
                            </b-button>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12 d-md-flex pl-md-0">
                        <p class="footer-text-emissons">Estimated total emissions: {{ currentJourney.carbon_emission }} kg CO<sub>2</sub></p>
                    </div>
                    <div class="col-md-4 col-sm-12 d-md-flex">
                        <p class="footer-text-total">Total estimated cost: {{ currentJourney.cost }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND];

export default {
    data() {
        return {
            showingJourneyType: 'depart',
            showingReturnType: false,
            saveSuccess: false,
            brand: whitelabel.brand,
            enableUserAccounts: whitelabel.enableUserAccounts,
        };
    },
    props: {
        journeyType: {
            type: String,
            default: 'depart',
        },
        showingReturn: {
            default: true,
            type: Boolean,
        },
    },
    computed: {
        ...mapState([
            'currentJourney',
            'user',
            'auth',
            'defaultSuccess',
        ]),
        ...mapGetters([
            'getIconNamesByStage',
            'getCo2',
        ]),
        icons() {
            return this.getIconNamesByStage(this.showingJourneyType)
        },
        isJourneySaved() {
            return this.currentJourney.user_status === 'saved'
        },
        lowestCo2() {
            const lowest = this.getCo2[0]
            return lowest
        },
        highestCo2() {
            const highest = this.getCo2[this.getCo2.length - 1]
            return highest
        },
        showEnterpriseLogo() {
            return this.currentJourney && this.currentJourney.depart.transport_mode === 'carclub' && this.currentJourney.depart.steps[0].car_club.provider.toLowerCase() === 'enterprise'
        },
        showCoWheelsLogo() {
            return this.currentJourney && this.currentJourney.depart.transport_mode === 'carclub' && this.currentJourney.depart.steps[0].car_club.provider.toLowerCase() === 'co-wheels'
        },
        carClubLink() {
            if (this.currentJourney && this.currentJourney.depart.transport_mode === 'carclub') {
                return this.currentJourney.depart.steps[0].car_club.promo_link
            }
            return false;
        },
    },
    methods: {
        ...mapGetters(['getUserLogged']),
        ...mapActions(['saveJourneyRequest']),

        handleJourneyTypeChange(type) {
            this.showingJourneyType = type
            this.$emit('change-type', type)
        },
        toggleJourneyType(type) {
            this.showingReturnType = type
            this.$emit('toggle-type', type)
        },
        saveJourney() {
            this.saveJourneyRequest(this.currentJourney.id)
        },
    },
    mounted() {
        this.showingJourneyType = this.journeyType
        this.showingReturnType = this.showingReturn
    },
}
</script>
<style lang="scss"></style>
